module.exports = __webpack_public_path__ + "static/media/tuv.615f49d7.svg";